import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fromReservation } from 'store/selectors';
import { changeVehicleRegNo, changeTrailerRegNo } from 'store/actions';

import { Vehicle } from 'components';

const VehicleContainer = props => <Vehicle {...props} />;

const mapStateToProps = (state, { id }) => {
  const vehicle = fromReservation.getVehicle(state, id);

  return {
    id: vehicle.id,
    number: vehicle.number,
    description: vehicle.description,
    type: vehicle.type,
    regNo: vehicle.regNo,
    trailer: vehicle.trailer,
    trailerId: vehicle.trailerId,
    trailerRegNo: vehicle.trailerRegNo,
    readonly: fromReservation.isCabinsAllocated(state, fromReservation.getActiveDepartureId(state)),
  };
};

const mapDispatchToProps = (dispatch, { id }) => ({
  onRegNoChange: value => dispatch(changeVehicleRegNo(id, value)),
  onTrailerRegNoChange: value => dispatch(changeTrailerRegNo(id, value)),
});

VehicleContainer.propTypes = {
  id: PropTypes.string.isRequired,
  trailerId: PropTypes.string,
  readonly: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleContainer);



// WEBPACK FOOTER //
// ./src/containers/Vehicle.js